import { Controller } from "@hotwired/stimulus";

export default class ShareController extends Controller {
  static values = {
    url: String,
    type: String,
    id: Number,
    klass: String
  };

  popup() {
    const url = this.urlValue;
    globalThis.open(url, "share_dialog", "width=626,height=450");
  }
}
